import { Dispatch, SetStateAction } from "react"
import { Grid } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import {
    SelectedMainUserState,
    CreateOrderDialogFlow,
    CreateOrderDialogType,
    AvailableModules,
} from "../createOrderTypes"
import { MeetingServiceOrder } from "../../../../modules/merchant/accounting/accounting/accountingTypes"
import { MeetingServiceFormContainer } from "../components/meetingService/MeetingServiceFormContainer"
import { OutlookBookingSuccessArgs } from "../../../../modules/order/pages/outlookCreateOrderTypes"
import { MainOrderFormikRef, MeetingServiceTabValues } from "../components/form/formTypes"
import { ResourceBookingWrapper } from "../components/resource/ResourceBookingWrapper"
import { InitialEventState } from "../components/resource/useInitialEventState"
import { useCreateOrderDialogType } from "../hooks/useCreateOrderDialogType"
import { OrderContextState, OrderFormStatus } from "./helpers"
import { CreateOrderType } from "../helpers"

const useStyles = makeStyles()((_theme) => ({
    contentSlide: {
        height: "100%",
        overflow: "auto",
    },
}))
type TabContentProps = Readonly<{
    confirmBookingDialog: boolean
    setConfirmBookingDialog: Dispatch<SetStateAction<boolean>>
    initialEventState: InitialEventState
    setInitialEventState: (value: any) => void
    handleChangeOrderType: (type: CreateOrderType) => void
    handleCancelClick: () => void
    handleClose: () => void
    user: SelectedMainUserState
    dialogType: CreateOrderDialogType
    orderContext: OrderContextState
    flowConfig?: CreateOrderDialogFlow
    setOrderContext: Dispatch<SetStateAction<OrderContextState>>
    orderFormStatusRef: React.MutableRefObject<OrderFormStatus>
    handleOpenSelectPriceListsDialog: () => void
    orderType: CreateOrderType
    isDrawerOpen: boolean
    orderDetails?: MeetingServiceOrder
    handleSubmitMeetingService: (values: MeetingServiceTabValues) => void
    outerFormik: MainOrderFormikRef
    handleOutlookBookingCompleted?: (args: OutlookBookingSuccessArgs) => void
    availableModules: AvailableModules
}>

export const TabContent = ({
    confirmBookingDialog,
    setConfirmBookingDialog,
    initialEventState,
    setInitialEventState,
    handleChangeOrderType,
    handleCancelClick,
    handleClose,
    user,
    dialogType,
    orderContext,
    flowConfig,
    setOrderContext,
    orderFormStatusRef,
    handleOpenSelectPriceListsDialog,
    orderType,
    isDrawerOpen,
    orderDetails,
    handleSubmitMeetingService,
    outerFormik,
    handleOutlookBookingCompleted,
    availableModules,
}: TabContentProps) => {
    const { classes } = useStyles()

    const { isSpecialDialog } = useCreateOrderDialogType(dialogType)

    const tabs = [
        {
            animationKey: CreateOrderType.RESOURCE_BOOKING,
            content: (
                <Grid container className={classes.contentSlide}>
                    <ResourceBookingWrapper
                        confirmBookingDialog={confirmBookingDialog}
                        setConfirmBookingDialog={setConfirmBookingDialog}
                        initialEventState={initialEventState}
                        setInitialEventState={setInitialEventState}
                        handleChangeOrderType={handleChangeOrderType}
                        handleCancelClick={handleCancelClick}
                        orderContext={orderContext}
                        handleClose={handleClose}
                        user={user}
                        flowConfig={flowConfig}
                        setOrderContext={setOrderContext}
                        orderFormStatusRef={orderFormStatusRef}
                        orderDetails={orderDetails}
                        outerFormik={outerFormik}
                        handleOutlookBookingCompleted={handleOutlookBookingCompleted}
                        dialogType={dialogType}
                        availableModules={availableModules}
                    />
                </Grid>
            ),
            direction: "left",
        },
        {
            animationKey: CreateOrderType.MEETING_SERVICE,
            content: (
                <MeetingServiceFormContainer
                    user={user}
                    handleClose={handleClose}
                    dialogType={dialogType}
                    handleOpenSelectPriceListsDialog={handleOpenSelectPriceListsDialog}
                    flowConfig={flowConfig}
                    isDrawerOpen={isDrawerOpen}
                    orderType={orderType}
                    orderDetails={orderDetails}
                    orderContext={orderContext}
                    handleSubmitMeetingService={handleSubmitMeetingService}
                    outerFormik={outerFormik}
                />
            ),
            direction: "right",
        },
    ]

    return isSpecialDialog ? tabs.filter((t) => t.animationKey === CreateOrderType.MEETING_SERVICE) : tabs
}
